import TaxCountryList from "../../../../component/tax-types/tax-list/TaxCountryList";

function TaxType() {
  return (
    <div className="page-body">
      <TaxCountryList />
    </div>
  );
}

export default TaxType;
